// components/Desktop/Pages/WhoWeAre.js
import React from 'react';
const WhoWeAre = () => {
  return (
    // <div className={styles.container}>
    //   <h1 className={styles.title}>We’re here to help you find the best matches</h1>
    //   <h2 className={styles.subtitle}>by mixing social & dating to help you find likeminded people and form life-<br/>long bonds, regardless of where you want things to go</h2>

    //   <div className={styles.buttonContainer}>
    //     <a href="https://play.google.com/store/apps/" target="_blank" rel="noopener noreferrer">
    //       <img src={googlePlayLogo} alt="Get it on Google Play" className={styles.googlePlayBadge} />
    //     </a>
    //     <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
    //       <img src={appleStoreLogo} alt="Download on the App Store" className={styles.appleStoreBadge} />
    //     </a>
    //   </div>
    // </div>
    
    <div style={{
      position: 'relative', 
      height: '100vw', 
      overflow: 'hidden', 
      margin: 0, 
      paddingBottom: '10vw'
    }}>
      <img
        src="/whoweare.jpg" 
        alt="Descriptive alt text"
        style={{
          width: '100%', 
          objectFit: 'cover',
        }}
      />

      <div style={{
        position: 'absolute', 
        bottom: '10%',  
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        padding: '2rem', 
        borderRadius: '1rem 1rem 0 0', 
        width: '70%', 
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}> 
          <img 
            src="/logo.png"  // Assuming logo.png is in the public folder
            alt="Logo"
            style={{ maxWidth: '30%' }} // Ensure logo scales down if needed
          />
        </div>

        <div style={{  
  position: 'relative', 
  overflow: 'visible' 
}}>
  <h2 style={{ 
    position: 'absolute', 
    bottom: '-1.5em', 
    left: '50%', 
    transform: 'translateX(-50%)', /* Center it properly */
    color: '#438B4D',
    fontSize: 28,
    fontWeight: 'semi-bold',
    textAlign: 'center',
    fontFamily: 'NewZen-Bold',
    whiteSpace: 'nowrap' /* Prevent the text from wrapping */
  }}> 
    More than dating
  </h2>
</div>

      </div>
    </div>
  );
};

export default WhoWeAre;
